import CreateInvoice from '@/views/CreateInvoice';

export default [
  {
    path: '/create/invoice',
    name: 'CreateInvoice',
    component: CreateInvoice
  }
]